import { Component } from '@angular/core';
import { ContentTooltip } from 'src/app/models/content-tooltip';
import { environment } from '../../../environments/environment';
import { SharedStateService } from '../../services/shared-state/shared-state.service';

@Component({
    selector: 'app-start',
    templateUrl: './start.component.' + environment.brand + '.html',
    styleUrls: ['./start.component.' + environment.brand + '.css']
})
export class StartComponent {
    contentTooltips: ContentTooltip[] = [];

    constructor(private sharedStateService: SharedStateService) {
        //console.log('StartComponent.constructor');
        const pageName = 'Start';
        this.contentTooltips = this.sharedStateService.contentTooltips.filter(x => x.pageName == pageName);
        if (this.contentTooltips.length == 0) {
            this.sharedStateService.onContentTooltipLoaded.subscribe(() => {
                this.contentTooltips = this.sharedStateService.contentTooltips.filter(x => x.pageName == pageName);
            });
        }
    }

    onExistingCustomer(): void {
        this.sharedStateService.showEnterCustomerDetails(true);
    }

    onJustBrowsing(): void {
        this.sharedStateService.showJustBrowsingVehicleDetails();
    }
}
